import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import omit from 'lodash/omit';
import classnames from 'classnames';
import Button from '../../../../Button';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './FooterButton.scss';
const FooterButton = (props)=>{
    const { view, height, size = 'medium', className } = props;
    const isMobile = useContext(MobileContext);
    var _props_fullWidth;
    const fullWidth = (_props_fullWidth = props.fullWidth) !== null && _props_fullWidth !== void 0 ? _props_fullWidth : isMobile;
    return view === undefined ? /*#__PURE__*/ React.createElement(BrandedButton, _object_spread_props(_object_spread({}, omit(props, [
        'height'
    ])), {
        variant: "brand-green",
        size: size,
        className: classnames(s['new-ds-footer-btn'], fullWidth && s['full-width'], s[size], props.className)
    })) : /*#__PURE__*/ React.createElement(Button, _object_spread_props(_object_spread({}, props), {
        height: height || size,
        className: classnames(s['footer-btn'], fullWidth && s['full-width'], className)
    }));
};
FooterButton.displayName = 'FooterButton';
export default FooterButton;

//# sourceMappingURL=FooterButton.js.map